var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3592 42.1668H9.52588C3.77588 42.1668 3.77588 39.5793 3.77588 36.4168V34.5002C3.77588 33.446 4.63838 32.5835 5.69255 32.5835H40.1925C41.2467 32.5835 42.1092 33.446 42.1092 34.5002V36.4168C42.1092 39.5793 42.1092 42.1668 36.3592 42.1668Z",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7134 24.9168V32.5835H6.26758V24.9168C6.26758 17.5568 11.4617 11.4043 18.3809 9.9285C19.4159 9.6985 20.4892 9.5835 21.6009 9.5835H24.3801C25.4917 9.5835 26.5842 9.6985 27.6192 9.9285C34.5384 11.4235 39.7134 17.5568 39.7134 24.9168Z",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7916 8.62516C27.7916 9.08516 27.7341 9.50683 27.6191 9.9285C26.5841 9.6985 25.4916 9.5835 24.3799 9.5835H21.6008C20.4891 9.5835 19.4158 9.6985 18.3808 9.9285C18.2658 9.50683 18.2083 9.08516 18.2083 8.62516C18.2083 5.98016 20.3549 3.8335 22.9999 3.8335C25.6449 3.8335 27.7916 5.98016 27.7916 8.62516Z",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 21.0835H17.25",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.0531b39be9fad518cef8e84e66ee1ce4.svg";
export { ForwardRef as ReactComponent };